import { useGlobalError } from '../context/GlobalErrorContext';
import { Alert } from '@mui/material';
import { useEffect, useRef } from 'react';

function GlobalErrorAlert(props) {
  const { globalError } = useGlobalError();
  const alertRef = useRef(null);

  // auto-scroll to error
  useEffect(() => {
    if (globalError && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [globalError, alertRef]);

  if (!globalError) {
    return null;
  }

  return (
    <Alert ref={alertRef} severity="error" {...props} data-testid="global-error-alert">
      {globalError}
    </Alert>
  );
}

export default GlobalErrorAlert;
